import { Action } from '@ngrx/store';
import { OfferBucketLoad } from '../models/offer-bucket.model';

export enum OfferActionTypes {
  OPEN_BUCKET = '[Retail Offer] Open bucket',
  RESET = '[Retail Offer] Reset offer',
}

export class OpenBucketAction implements Action {
  readonly type = OfferActionTypes.OPEN_BUCKET;

  constructor(public payload: OfferBucketLoad) {}
}

export class OfferResetAction implements Action {
  readonly type = OfferActionTypes.RESET;

  constructor() {}
}

export type OfferActions = OpenBucketAction | OfferResetAction;
